package com.hyperether.goodjob.scenes.register

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.confirm_password
import com.hyperether.goodjob.resources.create_strong_password
import com.hyperether.goodjob.resources.new_password
import com.hyperether.goodjob.resources.pass_ic
import com.hyperether.goodjob.resources.save_password
import com.hyperether.goodjob.scenes.components.PasswordInputField
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun SetNewPasswordView(
    title: String,
    passwordInput: MutableState<String>,
    confirmPasswordInput: MutableState<String>,
    onSavePassword: () -> Unit
) {

    Dialog(
        onDismissRequest = {

        },
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.White)
                .verticalScroll(rememberScrollState())
                .disableMouseDragScrollOnWeb()
        ) {
            Column(
                modifier = Modifier
                    .padding(horizontal = 16.toScaleDp(), vertical = 16.toScaleDp())
                    .fillMaxWidth()
            ) {
                Text(
                    text = title,
                    fontSize = 24.toScaleSp(),
                    color = Color.Black,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Left,
                    modifier = Modifier.padding(top = 20.toScaleDp())
                )

                Text(
                    text = stringResource(Res.string.create_strong_password),
                    color = DarkGrey,
                    textAlign = TextAlign.Start,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier.padding(top = 10.toScaleDp())
                )

                Spacer(modifier = Modifier.height(10.toScaleDp()))

                PasswordInputField(
                    text = passwordInput,
                    placeholder = stringResource(Res.string.new_password),
                    isRegister = true
                )

                Spacer(modifier = Modifier.height(10.toScaleDp()))

                PasswordInputField(
                    text = confirmPasswordInput,
                    placeholder = stringResource(Res.string.confirm_password),
                    isRegister = true,
                    showMismatchError = confirmPasswordInput.value.isNotEmpty() && passwordInput.value != confirmPasswordInput.value,
                )

                FilledButton(
                    onClick = {
                        onSavePassword()
                    },
                    text = stringResource(Res.string.save_password),
                    modifier = Modifier.padding(top = 30.toScaleDp()),
                    isEnabled = passwordInput.value == confirmPasswordInput.value && passwordInput.value.length >= 8 && confirmPasswordInput.value.length >= 8
                )

            }
        }
    }
}

@Composable
fun SetPasswordWebView(
    title: String,
    passwordInput: MutableState<String>,
    confirmPasswordInput: MutableState<String>,
    onSavePassword: () -> Unit
) {
    val focusManager = LocalFocusManager.current
    val passwordRequester = remember { FocusRequester() }
    val password2Requester = remember { FocusRequester() }

    RegisterHolderView {
        val scrollState = rememberScrollState()

        Column(
            modifier = Modifier.fillMaxHeight()
                .verticalScrollbar(scrollState)
                .verticalScroll(scrollState)
                .disableMouseDragScrollOnWeb()
                .padding(
                    bottom = 30.toScaleDp(),
                    top = 32.toScaleDp(),
                    start = 100.toScaleDp(),
                    end = 100.toScaleDp()
                ),
            verticalArrangement = Arrangement.Center
        ) {
            Text(
                text = title,
                fontSize = 24.toScaleSp(),
                color = Color.Black,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Left,
            )
            Text(
                text = stringResource(Res.string.create_strong_password),
                color = DarkGrey,
                textAlign = TextAlign.Start,
                fontSize = 16.toScaleSp(),
                modifier = Modifier.padding(top = 4.toScaleDp())
            )
            Spacer(modifier = Modifier.height(24.toScaleDp()))
            RegisterPasswordInputFieldWeb(
                text = passwordInput,
                label = stringResource(Res.string.new_password),
                drawableResource = Res.drawable.pass_ic,
                focusManager = focusManager,
                isRegister = true
            )
            Spacer(modifier = Modifier.height(24.toScaleDp()))
            RegisterPasswordInputFieldWeb(
                text = confirmPasswordInput,
                label = stringResource(Res.string.confirm_password),
                drawableResource = Res.drawable.pass_ic,
                focusManager = focusManager,
                isRegister = true,
                showMismatchError = confirmPasswordInput.value.isNotEmpty() && passwordInput.value != confirmPasswordInput.value,
            )
            Spacer(modifier = Modifier.height(24.toScaleDp()))
            FilledButton(
                onClick = {
                    onSavePassword()
                },
                text = stringResource(Res.string.save_password),
                modifier = Modifier.padding(top = 30.toScaleDp()),
                isEnabled = passwordInput.value == confirmPasswordInput.value &&
                        passwordInput.value.isNotBlank() &&
                        passwordInput.value.length >= 8 &&
                        confirmPasswordInput.value.length >= 8
            )
        }
    }
}